async function load({ locals }) {
  return {
    ...locals
  };
}
export {
  load
};
